export const UPLOAD_STAGE = "upload";
export const PREVIEW_STAGE = "preview";
export const META_DATA_CHECK_STAGE = "checkMetaData";
